module.exports = __webpack_public_path__ + "fonts/CalibreSemiboldItalic.9ddd82ff.woff";